<template lang="pug">
div.py-8
  //- Fetching
  template(v-if="isFetching && !initialized")
    v-skeleton-loader.py-8.px-4(type="list-item-three-line@5")
  template(v-else)
    .text-md.font-semibold.mb-4 {{ $t('appointments') }}
    v-row.pb-2.pb-md-0(no-gutters)
      v-col(cols="12" md="7")
        v-tabs(v-model="appointmentTab" color="basic700" :height="44" :grow="isMobileScreen" active-class="font-semibold")
          v-tab.text-sm.font-medium.text-capitalize.px-4 {{ $t('upcoming') }}
          v-tab.text-sm.font-medium.text-capitalize.px-4 {{ $t('completed') }}
          v-tab.text-sm.font-medium.text-capitalize.px-4 {{ $t('no_show') }}
          v-tab.text-sm.font-medium.text-capitalize.px-4 {{ $t('cancelled') }}
          v-tab.text-sm.font-medium.text-capitalize.px-4 To be scheduled
      v-col(cols="12" md="5" align="end")
        .d-flex.align-center
          v-spacer
          v-btn(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
          //v-btn.selected-button(v-if="filtersCount" @click="clickFilter" text small)
          //  v-icon(size="20") $yzi-filter-funnel-01
          //  .ml-1 {{ filtersCount }}
          //v-btn(v-else @click="clickFilter" icon color="neutral500")
          //  v-icon(size="20") $yzi-filter-funnel-01
          .mr-2
            customize-column-menu(v-if="appointmentTab !== 4" type="hq_appointment" :showTooltip="false" iconSize="21")
            customize-column-menu(v-else type="hq_appointment_schedule" :showTooltip="false" iconSize="21")
          //v-menu(offset-y left rounded="lg")
          //  template(#activator="{ on }")
          //    v-btn.button-sm(color="neutral700" outlined depressed v-on="on") {{ $t('action') }}
          //      v-icon(right) mdi-chevron-down
          //  v-list.py-0
          //    v-list-item(@click="editMessageTemplate")
          //      v-list-item-title.text-sm.basic800--text {{ $t('edit_message_template') }}
          //v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addNewAppointment") {{ $t('new') }}
    v-divider

    .data-table
      v-data-table.table-custom.mt-sm-4.pb-6(:headers="headers" :items="appointments" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" item-class="text-sm" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" loader-height="2")
        template(v-slot:no-data)
          .mt-6
            v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
            .mt-2.p2.basic600--text {{ $t('no_list_available') }}
        //- Date
        template(v-slot:item.date="{ item, headers, index }")
          div.text-sm {{ item.start | humanizeDate }}
        //- Time
        template(v-slot:item.time="{ item, headers, index }")
          div(:id="`st-${index}`" style="position: relative;")
          div.my-3
            v-tooltip(top color="black" :attach="`#st-${index}`" min-width="340" max-width="500")
              template(#activator="{ on, attrs }")
                div(v-bind="attrs" v-on="on")
                  div.d-flex.align-center.font-semibold(v-if="item.start")
                    div.text-xs {{ item.start | displayTime2 }}
                    div.text-xs.ml-1(v-if="item.until") - {{ item.until | displayTime2 }} 
                  template(v-if="item.type === 'combo'")
                    div.text-xs(v-if="item.combo_set.length") {{ item.combo_set.length > 1 ? `${item.combo_set.length} services` : '1 service' }}
                  template(v-else)
                    div.text-xs(v-if="item.services.length") {{ item.services.length > 1 ? `${item.services.length} services` : '1 service' }}
              div.py-2
                div.text-xs.font-semibold Scheduled time
                div.mt-1(v-if="item.type === 'combo'")
                  template(v-for="(set, idx) in item.combo_set")
                    v-divider.neutral100.my-2(v-if="idx")
                    v-row(dense :key="set.id+set.pid")
                      v-col.pr-1(cols="6")
                        div.d-flex.align-center(v-if="set.start")
                          div.text-xs {{ set.start | displayTime2 }}
                          div.text-xs.ml-1(v-if="set.until") - {{ set.until | displayTime2 }} 
                      v-col.pl-1(cols="6")
                        div.text-xs(v-if="set.services.length") {{ set.services.map(m => m.name).join(', ') }}
                        div.text-xxs.mt-1 {{ set.provider.name }}
                v-row.mt-1(v-else dense)
                  v-col.pr-1(cols="6")
                    div.d-flex.align-center(v-if="item.start")
                      div.text-xs {{ item.start | displayTime2 }}
                      div.text-xs.ml-1(v-if="item.until") - {{ item.until | displayTime2 }} 
                  v-col.pl-1(cols="6")
                    div.text-xs(v-if="item.services.length") {{ item.services.map(m => m.name).join(', ') }}
                    div.text-xxs.mt-1 {{ item.provider.name }}
        //- Service
        template(v-slot:item.services="{ item, headers, index }")
          div(:id="`sv-${index}`" style="position: relative;")
          div.my-3
            v-tooltip(top color="black" :attach="`#sv-${index}`" content-class="black tooltip-top-arrow")
              template(#activator="{ on, attrs }")
                div(v-bind="attrs" v-on="on")
                  template(v-if="item.type === 'combo'")
                    template(v-for="(set, idx) in item.combo_set")
                      div.d-flex.align-center(v-if="idx < 2" :key="`comb-${index}-${idx}`")
                        div.text-sm.ellipsis-text(v-if="set.services.length") {{ set.services[0].name }}
                        div.text-sm(v-else) -
                        template(v-if="idx === 1 && item.combo_set.length > 2")
                          v-spacer
                          div.text-xs.font-medium +{{ item.combo_set.length - 2 }} more
                  template(v-else)
                    template(v-for="(service, idx) in item.services")
                      div.d-flex.align-center(v-if="idx < 2" :key="`serv-${index}-${idx}`")
                        div.text-sm.ellipsis-text {{ service.name }}
                        template(v-if="idx === 1 && item.services.length > 2")
                          v-spacer
                          div.text-xs.font-medium +{{ item.services.length - 2 }} more
              template(v-if="item.type === 'combo'")
                template(v-for="(set, idx) in item.combo_set")
                  div(:key="`ttcs-${index}-${idx}`") {{ idx + 1 }}. {{ set.services[0].name }}
              div(v-else)
                template(v-for="(service, idx) in item.services")
                  div(:key="`ttsv-${index}-${idx}`") {{ idx + 1 }}. {{ service.name }}
        //- Providers
        template(v-slot:item.provider="{ item, headers, index }")
          div(:id="`pv-${index}`" style="position: relative;")
          div.my-3(v-if="item.provider && Object.keys(item.provider).length")
            v-tooltip(top color="black" :attach="`#pv-${index}`" content-class="black tooltip-top-arrow")
              template(#activator="{ on, attrs }")
                div(v-bind="attrs" v-on="on")
                  y-chip.cursor-help(v-bind="attrs" v-on="on" :label="getProviderName(item)" size="sm" chip-class="pa-1" outlined)
                    template(#prepend)
                      div.mr-1
                        template(v-if="item.type === 'combo'")
                          template(v-for="(set, idx) in item.combo_set")
                            v-avatar(size="20" color="neutral300" :class="idx > 0 ? 'stack-image' : ''" :key="set.provider.id")
                              template(v-if="set.provider.profile_image")
                                v-img(:src="`https://img.yezza.io/50x50/${set.provider.profile_image.path}`")
                              v-icon(v-else color="neutral500" size="15") $yzi-user-03
                        v-avatar(v-else size="20" color="neutral300")
                          template(v-if="item.provider.profile_image")
                            v-img(:src="`https://img.yezza.io/50x50/${item.provider.profile_image.path}`")
                          v-icon(v-else color="neutral500" size="15") $yzi-user-03
                        
              template(v-if="item.type === 'combo' && item.combo_set.length > 1")
                div(v-for="(set, idx) in item.combo_set" :key="`ttpv-${index}-${idx}`") {{ idx + 1 }}. {{ set.provider.name }}
              div(v-else) {{ item.provider.name }}
        //- Payment
        template(v-slot:item.paid="{ item, headers, index }")
          div.d-flex.align-center
            v-icon.mr-2(v-if="item.paid === false" :color="'danger500'" size="22") $yzi-alert-circle-solid
            v-icon.mr-2(v-else :color="'success500'" size="22") $yzi-check-circle-solid
            div.text-sm {{ item.paid === null ? 'N/A' : item.paid ? 'Paid' : 'Unpaid' }}
        //- Responses
        template(v-slot:item.responses="{ item, headers, index }")
          y-button(label="View response" size="sm" underline button-class="px-0" @click="openAppointmentDetails(item)")
        //- Sent status
        template(v-slot:item.contacted="{ item, headers, index }")
          div.text-sm {{ item.lead.taggings.find(f => f.tagging === 'contacted') ? 'Sent' : 'Pending' }}
        //- Total sessions
        template(v-slot:item.total_sessions="{ item, headers, index }")
          div.text-sm {{ item.total_sessions }}
        //- Scheduled
        template(v-slot:item.scheduled="{ item, headers, index }")
          div.text-sm {{ (item.total_sessions - item.pending) || 0 }}
        //- Dates Pending
        template(v-slot:item.pending="{ item, headers, index }")
          div.text-sm.danger500--text {{ item.pending }}
        //- Actions
        template(v-slot:item.actions="{ item, headers, index }")
          div.d-flex.align-center.justify-end.py-3(@click.stop)
            v-btn(icon small @click="clickWhatsapp(item)")
              v-icon mdi-whatsapp
            //v-menu(offset-x :top="menuPositionTop(index)" left attach rounded="lg")
            //  template(#activator="{ on }")
            //    v-btn.ml-2(icon small v-on="on")
            //      v-icon mdi-dots-horizontal
            //  v-list.py-0
            //    template(v-for="(action, actidx) in actionList")
            //      template(v-if="action.id !== 'record' || (action.id === 'record' && item.paid === false)")
            //        v-divider(v-if="actidx !== 0")
            //        v-list-item(@click="action.action(item)" :key="'action-' + actidx")
            //          v-list-item-title.text-sm.basic800--text {{ action.text }}
            //    template(v-if="item.lead && item.lead.taggings.find(f => f.tagging === 'contacted')")
            //      v-divider
            //      v-list-item(@click="openMarkSentPending(item)")
            //        v-list-item-title.text-sm.basic800--text {{ $t('mark_sent_pending') }}
      
      div.d-flex.align-center.mb-4(v-if="totalCount > pageSize")
        v-spacer
        div
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

    filter-appointment-drawer(:open.sync="showFilterDrawer" @done="doneFilter")
    .modals
      add-appointment(v-if="openNewAppointmentDialog" :open.sync="openNewAppointmentDialog" @closed="closed" @reset="reset" @advance="openAdvanceAppointment()")
      add-advance-appointment(v-if="openAdvAppointmentDialog" :open.sync="openAdvAppointmentDialog" :patient="selectedPatient" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
      view-appointment-details(v-if="openAppointmentDetailsDialog" :open.sync="openAppointmentDetailsDialog" :selectedAppointment="selectedAppointment" :tabIndex="appointmentTab" @closed="closed" @reset="reset" @advance="openAdvanceAppointment($event)")
      mark-as-arrived(v-if="openMarkAsArrivedDialog" :open.sync="openMarkAsArrivedDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
      reschedule-date(v-if="openRescheduleDateDialog" :open.sync="openRescheduleDateDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
      cancel-appointment(v-if="openCancelAppointmentDialog" :open.sync="openCancelAppointmentDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
      follow-up-appointment(v-if="openFollowUpDialog" :open.sync="openFollowUpDialog" :selectedAppointment="selectedAppointment" show-open-advance @closed="closed" @reset="reset" @advance="openAdvanceAppointment($event)")
      record-payment(v-if="openRecordPaymentDialog" :open.sync="openRecordPaymentDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
      combo-record-payment(v-if="openComboRecordPaymentDialog" :open.sync="openComboRecordPaymentDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
      mark-sent-pending(v-if="openMarkSentPendingDialog" :open.sync="openMarkSentPendingDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
      edit-recurring-appointment-dialog(v-if="openEditRecurringAppointmentDialog" :open.sync="openEditRecurringAppointmentDialog" :recurFor="selectedAppointment.id" @closed="reset")
      edit-combo-appointment-dialog(v-if="openEditComboAppointmentDialog" :open.sync="openEditComboAppointmentDialog" :selectedAppointment="selectedAppointment" :comboFor="selectedAppointment.id" @closed="reset")

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import AddAppointment from '@/components/clinic/dialogs/AddAppointment.vue'
import AddAdvanceAppointment from '@/components/clinic/dialogs/AddAdvanceAppointment.vue'
import ViewAppointmentDetails from '@/components/clinic/dialogs/ViewAppointmentDetails.vue'
import MarkAsArrived from '@/components/clinic/dialogs/MarkAsArrived.vue'
import RescheduleDate from '@/components/clinic/dialogs/RescheduleDate.vue'
import CancelAppointment from '@/components/clinic/dialogs/CancelAppointment.vue'
import FollowUpAppointment from '@/components/clinic/dialogs/FollowUpAppointment.vue'
import RecordPayment from '@/components/clinic/dialogs/RecordPayment.vue'
import ComboRecordPayment from '@/components/clinic/appointment/advance/ComboRecordPayment.vue'
import MarkSentPending from '@/components/clinic/dialogs/MarkSentPending.vue'
import EditRecurringAppointmentDialog from '@/components/clinic/appointment/advance/EditRecurringAppointmentDialog.vue'
import EditComboAppointmentDialog from '@/components/clinic/appointment/advance/EditComboAppointmentDialog.vue'
import FilterAppointmentDrawer from '@/components/clinic/appointment/filter/FilterAppointmentDrawer.vue'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'

export default {
  name: 'Appointment',
  components: { AddAppointment, AddAdvanceAppointment, ViewAppointmentDetails, MarkAsArrived, RescheduleDate, CancelAppointment, FollowUpAppointment, RecordPayment, ComboRecordPayment, MarkSentPending, EditRecurringAppointmentDialog, EditComboAppointmentDialog, FilterAppointmentDrawer, CustomizeColumnMenu },
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isFetching: false,
      initialized: false,
      openNewAppointmentDialog: false,
      openAdvAppointmentDialog: false,
      openAppointmentDetailsDialog: false,
      openMarkAsArrivedDialog: false,
      openRescheduleDateDialog: false,
      openCancelAppointmentDialog: false,
      openFollowUpDialog: false,
      openRecordPaymentDialog: false,
      openComboRecordPaymentDialog: false,
      openMarkSentPendingDialog: false,
      openEditRecurringAppointmentDialog: false,
      openEditComboAppointmentDialog: false,
      selectedAppointment: null,
      selectedPatient: null,
      appointmentTab: 0,
      searchText: '',
      pageSize: 20,
      totalCount: 0,
      currentPage: 1,
      appointments: [],
      selectedAppointments: [],
      showFilterDrawer: false,
      statuses: [
        { status: 'new,processed', id: 0 },
        { status: 'received', id: 1 },
        { status: 'absent', id: 2 },
        { status: 'cancelled', id: 3 },
      ],
      actions: [
        { id: 'mark', text: this.$t('mark_as_arrived'), action: (item) => (this.openMarkAsArrived(item)) },
        { id: 'reschedule', text: this.$t('reschedule_new_date'), action: (item) => (this.openRescheduleDate(item)) },
        { id: 'cancel', text: this.$t('cancel_this_appointment'), action: (item) => (this.openCancelAppointment(item)) },
        { id: 'followup', text: this.$t('create_followup_appointment'), action: (item) => (this.openFollowUpAppointment(item)) },
        { id: 'record', text: this.$t('record_payment'), action: (item) => (this.openRecordPayment(item)) },
        { id: 'scheduled', text: 'Set date & time', action: (item) => (this.openEditScheduledAppointment(item)) },
      ],
      selectedDuration: { id: 'month', text: 'This month' },
      showSearchField: false,
      filters: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      clinic: 'clinic/getClinic',
      appointmentFields: 'hq/getAppointmentFields',
      appointmentScheduleFields: 'hq/getAppointmentScheduleFields',
    }),
    actionList () {
      const upcoming = ['mark', 'reschedule', 'cancel', 'followup', 'record']
      const completed = ['followup', 'record']
      const absent = ['mark', 'reschedule', 'cancel', 'followup', 'record']
      const cancelled = ['reschedule', 'followup']
      const scheduled = ['scheduled']
      if (this.appointmentTab === 0) { return upcoming.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      if (this.appointmentTab === 1) { return completed.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      if (this.appointmentTab === 2) { return absent.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      if (this.appointmentTab === 3) { return cancelled.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      if (this.appointmentTab === 4) { return scheduled.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      return this.actions
    },
    headers () {
      let fields = []
      if (this.appointmentTab === 4) {
        fields = this.appointmentScheduleFields.filter(item => item.enable)
      } else {
        fields = this.appointmentFields.filter(item => item.enable)
      }
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
        item['class'] = 'text-xs font-bold neutral500--text text-uppercase'
      })
      const actions = {
        text: 'Actions',
        value: 'actions',
        enable: true,
        class: 'text-xs font-bold text-end neutral500--text text-uppercase',
        sortable: false
      }
      return [...fields, actions]
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    filtersCount () {
      if (this.filters) {
        let count = this.filters.length
        this.filters.forEach(item => {
          const betweenKeys = ["date__lte", "time__lte"]
          if (betweenKeys.includes(item.key)) {
            count--
          }
        })
        return count
      }
      return 0
    },
    patientId () {
      if (this.$route.params.id) return parseInt(this.$route.params.id)

      return null
    }
  },
  watch: {
    appointmentTab () {
      this.searchText = null
      this.currentPage = 1
      this.fetchAppointments()
    },
    pageSize () {
      this.currentPage = 1
      this.fetchAppointments()
    }
  },
  mounted () {
    this.fetchAppointments()
    if (!this.clinic) {
      this.fetchClinic()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchClinic () {
      this.$axios.get(`/clinics/${this.company.slug}?expand=form,company`)
        .then(resp => {
          this.$store.commit('clinic/setClinic', resp.data)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
    },
    fetchAppointments () {
      this.isFetching = true
      this.appointments = []
      this.totalCount = 0
      if (this.appointmentTab === 4) {
        this.fetchScheduledAppointments()
      } else {
        this.fetchRegularAppointments()
      }
    },
    fetchRegularAppointments () {
      const params = {
        patient_uid: this.patientId,
        page_size: this.pageSize,
        page: this.currentPage,
        search: this.searchText || '',
        statuses: this.statuses.find(f => f.id === this.appointmentTab).status || '',
        ordering: 'start'
      }
      if ((params.statuses.includes('new') || params.statuses.includes('processed')) && this.selectedDuration.id !== 'all') {
        params['span'] = this.selectedDuration.id
      }
      if (this.filters && this.filters.length) {
        this.filters.forEach(filter => {
          params[filter.key] = filter.value
        })
        delete params.span
      }
      this.$axios.get(`/clinics/${this.company.slug}/hq/appointments`, { params })
        .then(resp => {
          if (resp?.data.results) {
            this.appointments = resp.data.results
            this.appointments.map(m => {
              m.checked = false
              m.company_name = m.company.name
            })
          }
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetching = false
          this.initialized = true
        })
    },
    fetchScheduledAppointments () {
      const params = {
        patient_uid: this.patientId,
        page_size: this.pageSize,
        page: this.currentPage,
        search: this.searchText || '',
        ordering: 'start',
        pending: true
      }
      if (this.filters && this.filters.length) {
        this.filters.forEach(filter => {
          params[filter.key] = filter.value
        })
        delete params.span
      }
      this.$axios.get(`/clinics/${this.company.slug}/hq/appointments/series`, { params })
        .then(resp => {
          if (resp?.data.results) {
            this.appointments = resp.data.results
            this.appointments.map(m => {
              m.checked = false
              m.company_name = m.company.name
            })
          }
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetching = false
          this.initialized = true
        })
    },
    pageChanged () {
      this.fetchAppointments()
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchAppointments()
    }, 750),
    closed () {
      this.selectedAppointments = []
      this.selectedAppointment = null
      this.selectedPatient = null
    },
    reset () {
      this.selectedAppointments = []
      this.selectedAppointment = null
      this.selectedPatient = null
      this.currentPage = 1
      this.fetchAppointments()
    },
    addNewAppointment () {
      this.openNewAppointmentDialog = true
    },
    openAppointmentDetails (item) {
      if (this.appointmentTab === 4) {
        this.selectedPatient = item.patient
        this.selectedAppointment = item
        this.openAdvAppointmentDialog = true
        return
      }
      this.selectedAppointment = item
      this.openAppointmentDetailsDialog = true
    },
    openMarkAsArrived (item) {
      this.selectedAppointment = item
      this.openMarkAsArrivedDialog = true
    },
    openRescheduleDate (item) {
      this.selectedAppointment = item
      this.openRescheduleDateDialog = true
    },
    openCancelAppointment (item) {
      this.selectedAppointment = item
      this.openCancelAppointmentDialog = true
    },
    openFollowUpAppointment (item) {
      this.selectedAppointment = item
      this.openFollowUpDialog = true
    },
    openRecordPayment (item) {
      this.selectedAppointment = item
      if (item.type === 'combo') {
        this.openComboRecordPaymentDialog = true
      } else {
        this.openRecordPaymentDialog = true
      }
    },
    openMarkSentPending (item) {
      this.selectedAppointment = item
      this.openMarkSentPendingDialog = true
    },
    openEditScheduledAppointment (item) {
      this.selectedAppointment = item
      if (item.type === 'recur') {
        this.openEditRecurringAppointmentDialog = true
      } else if (item.type === 'combo') {
        this.openEditComboAppointmentDialog = true
      }
    },
    openAdvanceAppointment (data) {
      if (data) { this.selectedPatient = data }
      this.selectedAppointment = null
      this.openFollowUpDialog = false
      this.openAppointmentDetailsDialog = false
      this.openNewAppointmentDialog = false
      this.openAdvAppointmentDialog = true
    },
    editMessageTemplate () {
      this.$router.push('/admin/clinic/message-template')
    },
    clickWhatsapp (item) {
      if (this.appointmentTab === 4) {
        window.open(`https://api.whatsapp.com/send?phone=${item.patient.phone}`)
        return
      }
      const endpoint = `/leads/${item.lead.pid}/taggings/contacted`
      this.$axios.patch(endpoint)
        .then(resp => {
          this.updateActivityLog(endpoint, resp, item.lead.pid)
          const taggings = [resp.data]
          this.$set(item.lead, 'taggings', taggings)
        })
        .catch(() => {})

      let storeUrl = `https://${this.company.slug}.yezza.co/appointment`

      let message = `Hi ${item.lead.name}!%0d%0a%0d%0aWe see that you missed your appointment with ${item.provider.name} at ${this.$options.filters.displayTime2(item.time)}.%0d%0a%0d%0aWould you like to book another appointment? You can do so here:%0d%0a%0d%0a${storeUrl}`
      message = this.$options.filters.encodeSymbols(message)
      if (this.getMessageTemplate()) {
        message = this.getMessageTemplate()
        message = message.split('{{name}}').join(item.lead.name ? encodeURIComponent(item.lead.name) : '')
        message = message.split('{{doctor}}').join(item.provider.name ? encodeURIComponent(item.provider.name) : '')
        // message = message.split('{{doctor}}').join(item.providers.length && item.providers.map(m => m.name).join() ? encodeURIComponent(item.providers.map(m => m.name).join(', ')) : '')
        message = message.split('{{service}}').join(item.services.length && item.services.map(m => m.name).join() ? encodeURIComponent(item.services.map(m => m.name).join(', ')) : '')
        message = message.split('{{date}}').join(item.start ? encodeURIComponent(this.$options.filters.humanizeDate(item.start)) : '')
        message = message.split('{{time}}').join(item.start ? encodeURIComponent(this.$options.filters.displayTime2(item.start)) : '')
        message = message.split('{{appointment_link}}').join(storeUrl || '')
        message = message.split('{{pre_appt_instruction}}').join(item.service.instructions.pre_appointment ? encodeURIComponent(item.service.instructions.pre_appointment.label + '\n\n' + item.service.instructions.pre_appointment.instructions) : '')
        message = message.split('{{post_appt_instruction}}').join(item.service.instructions.post_appointment ? encodeURIComponent(item.service.instructions.post_appointment.label + '\n\n' + item.service.instructions.post_appointment.instructions) : '')
        message = message.split(/\n/g).join('%0d%0a')
        message = this.$options.filters.encodeSymbols(message)
      }
      // const platform = navigator.platform || ''
      let prefix = 'api'
      // if (platform.toLowerCase().includes('win')) {
      //   prefix = 'web'
      // }
      window.open(`https://${prefix}.whatsapp.com/send?phone=${item.lead.phone}&text=${message}&app_absent=1`)
      setTimeout(() => {
        window.open(`https://${prefix}.whatsapp.com/send?phone=${item.lead.phone}&text=${message}&app_absent=1`)
      }, 200)
    },
    getMessageTemplate () {
      if (!this.clinic) {
        return null
      }
      if (this.appointmentTab === 0) {
        return this.clinic.upcoming_reminder
      } else if (this.appointmentTab === 2) {
        return this.clinic.absent_reminder
      } else {
        return this.clinic.review_reminder
      }
    },
    getProviderName (item) {
      let str = ''
      if (item.type === 'combo' && item.combo_set.length > 1) {
        str = item.combo_set.length + ' providers'
      } else {
        str = item.provider.name
        if (str.length > 15) {
          str = str.substring(0, 15 - 3) + '...';
        }
      }
      return str
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    clickFilter () {
      this.showFilterDrawer = true
    },
    doneFilter (filters) {
      this.filters = filters
      this.currentPage = 1
      this.fetchAppointments()
    },
    updateActivityLog (endpoint, response, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'appointment',
        activity: this.appointmentTab === 0 ? 'Send reminder to upcoming appointment' : this.appointmentTab === 2 ? 'Send reminder to no show appointment' : 'Send reminder to review appointment' ,
        raw_data: { endpoint, response: response.data }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.appointments.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  svg.v-icon.notranslate.v-data-table-header__icon {
    height: 8px !important;
    width: 8px !important;
    margin-left: 8px;
  }
  //.v-data-table__wrapper table tbody tr:hover{
  //  cursor: pointer;
  //  background: var(--v-neutral200) !important;
  //}
  .table-custom {
    .v-data-table__wrapper {
      overflow: visible !important;
    }
  } 
}
.v-text-field--outlined {
  fieldset {
    border-color: var(--v-primary200);
  } 
}
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
.table-word-break {
  word-break: break-word;
}
.v-tooltip__content {
  top: unset !important;
  left: unset !important;
  /* margin-top: -45px !important; */
  position: absolute;
  bottom: 0;
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  max-width: 260px;
}
.stack-image {
  margin-left: -13px;
}
</style>